// Подписи, группы и способ редактирования параметров рабочего места.
// Описания с сервера (officeparams.description) технические и неоднородные,
// поэтому для известных параметров показываем свои. Параметр без записи здесь
// попадает в «Прочее» с серверным описанием — новые параметры не потеряются.

export const PARAM_GROUPS = [
  { key: 'call', title: 'Вызов талонов' },
  { key: 'service', title: 'Обслуживание' },
  { key: 'time', title: 'Контроль времени' },
  { key: 'audio', title: 'Аудиозапись' },
  { key: 'sound', title: 'Озвучка' },
  { key: 'other', title: 'Прочее' },
  { key: 'support', title: 'Для техподдержки', collapsed: true },
];

// label не указан — остаётся серверное описание
const PARAM_META = {
  operatorAutoCallMode: { group: 'call', label: 'Автовызов талонов' },
  operatorAutoCallTime: {
    group: 'call', label: 'Интервал автовызова', unit: 'сек', dependsOn: 'operatorAutoCallMode',
  },
  operatorCallSelectTickets: {
    group: 'call',
    label: 'Вызов талона по номеру',
    hint: 'Оператор может вызвать конкретный талон, а не только следующий',
  },
  operatorQueuesSortByTicketsCount: {
    group: 'call',
    label: 'Сортировать очереди по числу талонов',
    hint: 'В окне оператора сверху очереди, где больше талонов',
  },

  operatorValidateTickets: { group: 'service' },
  operatorChangeTicketQueueEnable: { group: 'service' },
  operatorServedQuestionEnable: { group: 'service' },
  operatorForceSelectQuestion: { group: 'service', label: 'Не закрывать талон без выбранного вопроса' },

  closeTicketAfterRegulatoryQuestionTimeIsUp: { group: 'time' },
  timeToFinishNotify: {
    group: 'time', label: 'Предупредить о конце регламента за', unit: 'сек', hint: '0 — не предупреждать',
  },
  timeToFinishMakeYellow: { group: 'time', label: 'Подсветить таймер жёлтым за', unit: 'сек' },

  audioRecordEnabled: { group: 'audio', label: 'Аудиозапись обслуживания' },
  audioRecordFolder: { group: 'audio', label: 'Папка для записей', hint: 'Создаётся вручную' },
  audioRecordQuality: {
    group: 'audio', label: 'Качество записи', hint: '1 — низкое, 5 — высокое', control: 'scale', min: 1, max: 5,
  },

  wplaceDefaultSoundString: { group: 'sound' },

  letOperatorDebugLog: { group: 'support', label: 'Подробный лог оператора', hint: 'Для диагностики проблем' },
  qualityControlConfig: {
    group: 'support',
    label: 'Конфиг оценки качества',
    hint: 'JSON. Общие настройки удобнее менять в разделе «Планшеты оценки качества»',
    control: 'json',
  },
};

const CONTROL_BY_TYPE = {
  boolean: 'switch',
  number: 'number',
  soundstring: 'sound',
};

export function getParamMeta(param) {
  const meta = PARAM_META[param.param] || {};
  return {
    group: 'other',
    label: param.description,
    control: CONTROL_BY_TYPE[param.param_type] || 'text',
    ...meta,
  };
}

export function isValidJson(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
}
